import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {Injectable} from '@angular/core';
import {LovValueSummaryConverter} from '../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {
    CommunicationConfigurationEmailConverter
} from "../../../../../communication/configuration/email/common/api/model/converter/communicationConfigurationEmail.converter";
import {ReportDefinitionEmailConfigurationModel} from "../reportDefinitionEmailConfiguration.model";

@Injectable({
    providedIn: 'root'
})
export class ReportDefinitionEmailConfigurationConverter extends HttpModelConverter<ReportDefinitionEmailConfigurationModel> {

    constructor(private lovValueSummaryConverter: LovValueSummaryConverter,
                private communicationConfigurationEmailConverter: CommunicationConfigurationEmailConverter) {
        super();
    }

    protected createInstance(): ReportDefinitionEmailConfigurationModel {
        return new ReportDefinitionEmailConfigurationModel();
    }

    protected enrichObject(result: ReportDefinitionEmailConfigurationModel, src: ReportDefinitionEmailConfigurationModel) {
        result.type = this.lovValueSummaryConverter.convert(src.type);
        result.emailConfiguration = this.communicationConfigurationEmailConverter.convert(src.emailConfiguration);
    }

}
